import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/**
 * Base
 */
// Debug
const gui = new dat.GUI({
    width:300
})
const debug = {}

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

const cubeTextureLoeader = new THREE.CubeTextureLoader()

const environnementmap = cubeTextureLoeader.load([
    '/textures/environmentMaps/1/px.jpg',
    '/textures/environmentMaps/1/nx.jpg',
    '/textures/environmentMaps/1/py.jpg',
    '/textures/environmentMaps/1/ny.jpg',
    '/textures/environmentMaps/1/pz.jpg',
    '/textures/environmentMaps/1/nz.jpg'
])

environnementmap.encoding = THREE.sRGBEncoding

scene.background = environnementmap


const updateMaterial = () => 
{
    scene.traverse((child) =>{
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial){
            child.material.envMap = environnementmap
            child.material.envMapIntensity = debug.envMapIntensity

            child.castShadow = true
            child.receiveShadow = true
        }
    })
}


const gltfloader = new GLTFLoader()

gltfloader.load(
    'models/FlightHelmet/glTF/FlightHelmet.gltf',
    (gltf) => {
        const Helmet = gltf.scene
        scene.add(Helmet)

        Helmet.scale.set(10,10,10)
        Helmet.position.set(0,-4,0)
        Helmet.rotation.y = 3.3


        gui.add(Helmet.rotation, 'y').min(0).max(2*Math.PI).step(0.01).name('Rotation')

        updateMaterial()
    }
)



debug.envMapIntensity = 1
gui.add(debug, 'envMapIntensity').min(0).max(10).step(0.001).onChange(updateMaterial)












/**
 * Test sphere
 */


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(4, 1, - 4)
scene.add(camera)

/**
 * LIGHT    
 */


const light = new THREE.DirectionalLight('#ffffff',3)
light.position.set(0.25,3,-2.25)
light.castShadow = true;
light.shadow.camera.far = 15
light.shadow.mapSize.set(1024,1024)
scene.add(light)


gui.add(light, 'intensity').min(0).max(10).step(0.001).name('Light intensity')
gui.add(light.position, 'x').min(-5).max(5).step(0.01).name('Light X')
gui.add(light.position, 'y').min(-5).max(5).step(0.01).name('Light Y')
gui.add(light.position, 'z').min(-5).max(5).step(0.01).name('Light Z')







// Controls
const controls = new OrbitControls(camera, canvas)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ReinhardToneMapping
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFShadowMap
renderer.toneMappingExposure = 3



gui.add(renderer, 'toneMapping',{
    No: THREE.NoToneMapping,
    Linear: THREE.LinearToneMapping,
    Reinhard: THREE.ReinhardToneMapping,
    Cineon: THREE.CineonToneMapping,
    ACESFilmic:  THREE.ACESFilmicToneMapping
})
gui.add(renderer, 'toneMappingExposure').min(0).max(10).step(0.001)

/**
 * Animate
 */
const tick = () =>
{
    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()